module.exports = __webpack_public_path__ + "images/external-link.4a56ae5660eb7e0c6474877bbb8d08fd.svg";